__turbopack_context__.v({
  "animation": "BKiGUG_animation",
  "skeleton": "BKiGUG_skeleton",
  "skeletonOpacity": "BKiGUG_skeletonOpacity",
  "still": "BKiGUG_still",
  "udsSkeletonOpacity": "BKiGUG_udsSkeletonOpacity",
});
